// Base API URL (environment configurable)
import { ENV_CONFIG } from './config/env';
export const baseUrl = ENV_CONFIG.API_BASE_URL;

// Helper to generate full endpoint paths
const endpoint = (path) => `${baseUrl}${path}`;

// ------------------ AFRI Booking Dashboard API ENDPOINTS x-----------------------------

export const AdminLoginAPI = endpoint("/auth/admin/login");
export const AdminGetAgentAPI = endpoint("/admin/agents");
export const AdminGetAgentApartmentsAPI = (AGENT_ID) => endpoint(`/admin/agents/${AGENT_ID}/apartments`);
export const AdminChangeAgentStatusAPI = (AGENT_ID) => endpoint(`/admin/agents/${AGENT_ID}/status`);
export const AdminGetUsersAPI = endpoint("/admin/users");
export const AdminChangeUserStatusAPI = (USER_ID) => endpoint(`/admin/users/${USER_ID}/status`);
export const AdminGetAgentWalletsAPI = endpoint("/admin/agent-wallets");
export const AdminGetAgentWalletHistoryAPI = (agentId) => endpoint(`/admin/agent-wallets/${agentId}/history`);
export const AdminGetBlogsAPI = endpoint("/admin/blogs");
export const AdminCreateBlogAPI = endpoint("/admin/blogs");
export const AdminUpdateBlogAPI = (POST_ID) => endpoint(`/admin/blogs/${POST_ID}`);
export const AdminChangeBlogStatusAPI = (POST_ID) => endpoint(`/admin/blogs/${POST_ID}/status`);
export const AdminDeleteBlogAPI = (POST_ID) => endpoint(`/admin/blogs/${POST_ID}`);
export const AdminGetAnnouncementsAPI = endpoint("/admin/announcements");
export const AdminCreateAnnouncementAPI = endpoint("/admin/announcements");
export const AdminUpdateAnnouncementAPI = (ANNOUNCEMENT_ID) => endpoint(`/admin/announcements/${ANNOUNCEMENT_ID}`);
export const AdminChangeAnnouncementStatusAPI = (ANNOUNCEMENT_ID) => endpoint(`/admin/announcements/${ANNOUNCEMENT_ID}/status`);
export const AdminDeleteAnnouncementAPI = (ANNOUNCEMENT_ID) => endpoint(`/admin/announcements/${ANNOUNCEMENT_ID}`);
export const AdminGetStatsAPI = endpoint("/admin/stats");



export const AdminGetPendingApartmentsAPI = endpoint("/apartment/pending-apartments");
export const AdminGetPendingApartmentByIdAPI = (APARTMENT_ID) => endpoint(`/apartment/pending-apartments/${APARTMENT_ID}`);
export const AdminGetApprovedApartmentsAPI = endpoint("/admin/apartments/approved");
export const AdminGetCatalogueAPI = endpoint("/admin/apartments/catalogue");
export const AdminGetApprovedApartmentByIdAPI = (APARTMENT_ID) => endpoint(`/admin/apartments/approved/${APARTMENT_ID}`);
export const AdminToggleApartmentVerificationAPI = (APARTMENT_ID) => endpoint(`/admin/apartments/${APARTMENT_ID}/verification`);
export const AdminToggleApartmentFeaturedAPI = (APARTMENT_ID) => endpoint(`/admin/apartments/${APARTMENT_ID}/featured`);
export const AdminGetRemovedApartmentsAPI = endpoint("/admin/apartments/removed");
export const AdminRemoveApartmentAPI = (APARTMENT_ID) => endpoint(`/admin/${APARTMENT_ID}/remove`);
export const AdminGetResubmittedApartmentsAPI = endpoint("/admin/apartments/review");
export const AdminGetResubmittedApartmentDetailsAPI = (APARTMENT_ID) => endpoint(`/admin/apartments/review/${APARTMENT_ID}`);
export const AdminApproveResubmittedApartmentAPI = (APARTMENT_ID) => endpoint(`/admin/${APARTMENT_ID}/approve`);
export const AdminRejectResubmittedApartmentAPI = (APARTMENT_ID) => endpoint(`/admin/${APARTMENT_ID}/reject`);
export const AdminUpdateApartmentAPI = (APARTMENT_ID) => endpoint(`/apartment/admin/updateApartment/${APARTMENT_ID}`);
export const AdminApprovedApartment = (APARTMENT_ID) => endpoint(`/admin/apartments/${APARTMENT_ID}/status`);
export const AdminRejectApartment = (APARTMENT_ID) => endpoint(`/admin/${APARTMENT_ID}/reject`);
export const PlacesAutocompleteAPI = endpoint("/places/autocomplete");
export const PlaceDetailsAPI = (PLACE_ID) => endpoint(`/places/details/${encodeURIComponent(PLACE_ID)}`);

export const AdminGetBookingsSummaryAPI = endpoint("/admin/bookings");
export const AdminGetAllBookingsAPI = endpoint("/admin/bookings/all");
export const AdminCreateBackfillBookingAPI = endpoint("/admin/bookings/backfill");
export const AdminPreviewBackfillBookingPricingAPI = endpoint("/admin/bookings/backfill/price-preview");
export const AdminReleaseBookingPayoutAPI = (bookingId) => endpoint(`/admin/bookings/${bookingId}/release-payout`);
export const AdminManualSettleBookingAPI = (bookingId) => endpoint(`/admin/bookings/${bookingId}/manual-settlement`);

// Reservations Endpoints
export const AdminGetAllReservationsAPI = endpoint("/admin/reservations/all-agents");
export const AdminAcceptReservationAPI = (reservationId) => endpoint(`/admin/reservations/${reservationId}/accept`);
export const AdminGetAllChatsAPI = endpoint("/chat/admin/chats");
export const AdminGetChatMessagesAPI = (chatId) => endpoint(`/chat/admin/chats/${chatId}/messages`);
export const AdminGetAllBargainsAPI = endpoint("/admin/bargains");
export const AdminGetBargainByIdAPI = (bargainId) => endpoint(`/admin/bargains/${bargainId}`);
export const AdminGetBargainMinimumNightsAPI = endpoint("/admin/settings/bargain-minimum-nights");
export const AdminUpdateBargainMinimumNightsAPI = endpoint("/admin/settings/bargain-minimum-nights");


// ≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠OLD≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠
// Dashboard Endpoints
export const DashboardAPI = endpoint("/admin/dashboard");
export const GetAdminProfile = endpoint("/admin/profile");

// Bookings Endpoints
export const BookingsAPI = endpoint("/admin/bookings");
export const ViewBookingsAPI = endpoint("/admin/bookings/details/");

// Apartments Endpoints
export const ApartmentsAPI = endpoint("/admin/apartments");
export const AddApartmentsAPI = endpoint("/admin/apartments/add");
export const ViewApartmentsAPI = endpoint("/admin/apartments/details/");
export const updateApartmentsAPI = endpoint("/admin/apartments/details/");
export const deleteApartmentsAPI = endpoint("/admin/apartments/remove/");

// Landlords Endpoints
export const LandlordsAPI = endpoint("/admin/landlords");
export const AddLandlordsAPI = endpoint("/admin/landlords/add");
export const ViewLandlordDetailsAPI = endpoint("/admin/landlords/details/");
export const UpdateLandlordDetailsAPI = endpoint("/admin/landlords/update/");

// Reservation Request Endpoints
export const AcceptRequests = endpoint("/admin/reservation-requests/accept");
export const DeclinedRequests = endpoint("/admin/reservation-requests/decline");

// Users Endpoint
export const UsersAPI = endpoint("/admin/users");

// Staff Endpoints
export const StaffAPI = endpoint("/admin/staff");
export const AddStaffAPI = endpoint("/admin/staff/add");
export const ToggleStaffAPI = endpoint("/admin/staff/toggle/");
